export const defaultNavigationConfig = undefined;
